import auth from "../middleware/auth";
import guest from "../middleware/guest";

export default [
  { path: "/labor", redirect: "/labor/dashboard" },
  {
    path: "/moderation_map/:id",
    component: () => import("./../views/labor/moderation/mapSelectObj.vue")
  },
  // {
  //     path: "/labor/moderation",
  //     name: "moderation",
  //     component: () => import("./../views/labor/moderation/Moderation.vue"),
  //     meta: {
  //         middleware: [auth],
  //         breadcrumb: [
  //             {
  //                 title: "Лаборатория"
  //             },
  //             {
  //                 title: "Лаборатория",
  //                 url: "/labor/Moderation"
  //             },
  //             {
  //                 title: "Moderation",
  //                 active: true
  //             }
  //         ]
  //     },

  //     pageTitle: "Dashboard",
  //     rule: "editor"
  // },

  {
    path: "/labor/add_data/data_air",
    name: "Add_DataAir",
    component: () => import("./../views/labor/addData/addDataAir.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Лаборатория"
        },
        {
          title: "Лаборатория",
          i18n: "navmenu.data_input.entering_indicators.laboratory",
          url: "/labor/dashboard"
        },
        {
          title: "Занесение данных по загрязнении воздуха",
          i18n: "Recording air pollution data",
          active: true
        }
      ]
    },

    pageTitle: "DataAir",
    rule: "editor"
  },
  {
    path: "/labor/add_data/data_water",
    name: "Add_DataWater",
    component: () => import("./../views/labor/addData/addDataWater.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Лаборатория"
        },
        {
          title: "Лаборатория",
          i18n: "navmenu.data_input.entering_indicators.laboratory",
          url: "/labor/dashboard"
        },
        {
          title: "Занесение данных по загрязнении воды",
          i18n: "Entering data on water pollution",
          active: true
        }
      ]
    },

    pageTitle: "DataWater",
    rule: "editor"
  },
  {
    path: "/labor/add_data/data_ground",
    name: "Add_DataGround",
    component: () => import("./../views/labor/addData/addDataGround.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Лаборатория"
        },
        {
          title: "Лаборатория",
          i18n: "navmenu.data_input.entering_indicators.laboratory",
          url: "/labor/dashboard"
        },
        {
          title: "Занесение данных по загрязнении почвы",
          i18n: "Entering data on soil contamination",
          active: true
        }
      ]
    },

    pageTitle: "DataGround",
    rule: "editor"
  },
  {
    path: "/labor/dashboard",
    name: "Dashboard",
    component: () => import("./../views/labor/Dashboard.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          active: false,
          url: "/"
        },
        {
          title: "Ввод данных",
          i18n: "data_input",
          active: false
        },
        {
          title: "Эко-лаборатория",
          i18n: "Eco-lab",
          active: true
        },
        
      ]
    },

    pageTitle: "Dashboard",
    rule: "editor"
  },

  {
    path: "/labor/air",
    name: "Air",
    component: () => import("./../views/labor/Air.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
            title: "Home",
            active: false,
            url: "/"
          },
          {
            title: "Ввод данных",
            i18n: "data_input",
            active: false
          },
        {
          title: "Лаборатория",
          i18n: "navmenu.data_input.entering_indicators.laboratory",
          url: "/labor/dashboard"
        },
        {
          title: "Просмотр занесенных данных по загрязнению атмосферы ",
          i18n: "Viewing recorded air pollution data",
          active: true
        }
      ]
    },

    pageTitle: "Air",
    rule: "editor"
  },
  {
    path: "/labor/water",
    name: "Water",
    component: () => import("./../views/labor/Water.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
            title: "Home",
            active: false,
            url: "/"
          },
          {
            title: "Ввод данных",
            i18n: "data_input",
            active: false
          },
        {
          title: "Лаборатория",
          i18n: "navmenu.data_input.entering_indicators.laboratory",
          url: "/labor/dashboard"
        },
        {
          title: "Просмотр занесенных данных по загрязнению воды ",

          active: true
        }
      ]
    },

    pageTitle: "Water",
    rule: "editor"
  },
  {
    path: "/labor/ground",
    name: "Ground",
    component: () => import("./../views/labor/Ground.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
            title: "Home",
            active: false,
            url: "/"
          },
          {
            title: "Ввод данных",
            i18n: "data_input",
            active: false
          },
        {
          title: "Лаборатория",
          i18n: "navmenu.data_input.entering_indicators.laboratory",
          url: "/labor/dashboard"
        },
        {
          title: "Просмотр занесенных данных по загрязнению почвы ",
          active: true
        }
      ]
    },
    pageTitle: "Ground",
    rule: "editor"
  }
];
